import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import './Header.css'

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.sidebar') && !event.target.closest('.menu-button')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Prevent body scroll when sidebar is open and allow when closed
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Function to determine active link classes
  const getNavLinkClass = ({ isActive }) =>
    `hover:text-blue-500 transition-colors ${isActive ? 'text-blue-500' : ''}`;

  // Scroll to top and close sidebar on link click
  const handleNavLinkClick = () => {
    setIsOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* Fixed Header */}
      <header className="bg-white text-white py-2 lg:py-4 md:py-3 fixed top-0 w-full z-40 shadow-md">
        <div className="containers mx-auto px-6 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center Main_logo space-x-2">
            <a href="/">
              <img src={require('../../Img/MainLogo1.png')} alt="" className=" object-fit-contain" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex space-x-8 text-black Header_link_font text-sm font-medium">
            <NavLink to="/" onClick={() => window.scrollTo(0, 0)} className={getNavLinkClass}>Home</NavLink>
            <NavLink to="/about" onClick={() => window.scrollTo(0, 0)} className={getNavLinkClass}>About</NavLink>
            <NavLink to="/service" onClick={() => window.scrollTo(0, 0)} className={getNavLinkClass}>Service</NavLink>
            <NavLink to="/Career" onClick={() => window.scrollTo(0, 0)} className={getNavLinkClass}>Career</NavLink>
            <NavLink to="/Portfolio" onClick={() => window.scrollTo(0, 0)} className={getNavLinkClass}>Portfolio</NavLink>
            <NavLink to="/contact" onClick={() => window.scrollTo(0, 0)} className={getNavLinkClass}>Contact</NavLink>
          </nav>

          {/* Right Icons */}
          <div className="flex items-center space-x-6">
            {/* Contact Button - Hidden on small screens */}
            <div className="hidden lg:block cursor-pointer group inline-block relative overflow-hidden rounded-lg">
              <Link
                to="/contact"
                className="button_same px-8 py-2 rounded-lg text-white font-semibold button_text relative z-10 flex items-center gap-2 transition-all duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                <span className="relative z-10">CONTACT</span>
                <span className="transform translate-x-0 group-hover:translate-x-2 transition-transform duration-300">→</span>
              </Link>
              <span className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500 ease-in-out"></span>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden focus:outline-none menu-button p-2"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <X size={24} /> : <Menu size={24} className="text-black" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Sidebar Overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden">
          <div
            className={`sidebar fixed top-0 right-0 h-full w-80 max-w-[85vw] bg-[#0F0D1D] transform transition-transform duration-300 ease-in-out overflow-y-auto ${isOpen ? 'translate-x-0' : 'translate-x-full'
              }`}
          >
            {/* Sidebar Header */}
            <div className="flex justify-between items-center p-6 border-b border-gray-700">
              <div className="flex items-center space-x-2">
                <div className="flex items-center Main_logo space-x-2" >
                  <a href="/">
                    <img src={require('../../Img/MainLogo1.png')} alt="" className=" object-fit-contain" />
                  </a>
                </div>

              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-400 hover:text-white p-2"
              >
                <X size={24} />
              </button>
            </div>

            {/* Sidebar Navigation */}
            <nav className="p-6 space-y-6">
              <NavLink
                to="/"
                className={`block text-lg font-medium py-3 border-b border-gray-800 ${location.pathname === '/' ? 'text-blue-500' : 'text-white hover:text-[#1c74bb]'}`}
                onClick={handleNavLinkClick}
              >
                Home
              </NavLink>
              <NavLink
                to="/about"
                className={`block text-lg font-medium py-3 border-b border-gray-800 ${location.pathname === '/about' ? 'text-blue-500' : 'text-white hover:text-[#1c74bb]'}`}
                onClick={handleNavLinkClick}
              >
                About
              </NavLink>
              <NavLink
                to="/service"
                className={`block text-lg font-medium py-3 border-b border-gray-800 ${location.pathname === '/service' ? 'text-blue-500' : 'text-white hover:text-[#1c74bb]'}`}
                onClick={handleNavLinkClick}
              >
                Service
              </NavLink>
              <NavLink
                to="/Career"
                className={`block text-lg font-medium py-3 border-b border-gray-800 ${location.pathname === '/Career' ? 'text-blue-500' : 'text-white hover:text-[#1c74bb]'}`}
                onClick={handleNavLinkClick}
              >
                Career
              </NavLink>
              <NavLink
                to="/Portfolio"
                className={`block text-lg font-medium py-3 border-b border-gray-800 ${location.pathname === '/Portfolio' ? 'text-blue-500' : 'text-white hover:text-[#1c74bb]'}`}
                onClick={handleNavLinkClick}
              >
                Portfolio
              </NavLink>
              <NavLink
                to="/contact"
                className={`block text-lg font-medium py-3 border-b border-gray-800 ${location.pathname === '/contact' ? 'text-blue-500' : 'text-white hover:text-[#1c74bb]'}`}
                onClick={handleNavLinkClick}
              >
                Contact
              </NavLink>
            </nav>

            {/* Sidebar Contact Button */}
            <div className="p-6">
              <div className="cursor-pointer group inline-block relative overflow-hidden rounded-lg w-full">
                <Link
                  to="/contact"
                  className="w-full px-6 py-3 rounded-lg button_text text-white  relative z-10 flex items-center justify-center gap-2 transition-all duration-300  hover:bg-blue-700"
                  onClick={handleNavLinkClick}
                >
                  <span className="relative button_text z-10">CONTACT US</span>
                  <span className="transform translate-x-0 group-hover:translate-x-2 transition-transform duration-300">→</span>
                </Link>
              </div>
            </div>

            {/* Sidebar Footer */}
            <div className="absolute bottom-6 left-6 right-6">
              <div className="text-center">
                <p className="text-gray-400 text-sm mb-4">Follow us on social media</p>
                <div className="flex justify-center space-x-4">
                  <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors">
                    <span className="text-sm">f</span>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors">
                    <span className="text-sm">ig</span>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors">
                    <span className="text-sm">in</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Page Content Spacer */}
      <div className="h-16"></div> {/* This creates space for the fixed header */}
    </>
  );
};

export default Header;